import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgArrowIcon from './svgs/ArrowIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var ArrowIcon = (props => useIcon(SvgArrowIcon, SvgArrowIcon, props));

export { ArrowIcon as default };
